import { Droplets, Sparkles, Coffee, Package, Tag, Plane } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, SectionHead } from "./Section";

const ICONS = [Droplets, Sparkles, Coffee, Package, Tag, Plane];

const Applications = () => {
  const { t } = useLang();
  return (
    <section id="applications" className="px-6 lg:px-12 py-20 lg:py-32 scroll-mt-16" data-testid="applications-section">
      <SectionHead index="04" overline={t.applications.overline} title={t.applications.title} desc={t.applications.desc} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#232733] border border-[#232733] mt-14">
        {t.applications.items.map((a, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.06} className="bg-[#0A0B0E]">
              <div className="p-8 h-full group hover:bg-[#111318] transition-colors" data-testid={`application-card-${i}`}>
                <div className="flex items-center justify-between">
                  <Icon size={22} className="text-[#4D8BFF] group-hover:text-[#FF4D00] transition-colors" strokeWidth={1.5} />
                  <span className="font-mono text-[10px] text-[#647087]">0{i + 1}</span>
                </div>
                <h3 className="font-display text-xl font-medium tracking-tight text-white mt-6">{a.title}</h3>
                <p className="text-sm text-[#A0AABF] mt-3 leading-relaxed">{a.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default Applications;
